var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00000064",
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 224.045 224.045",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.436,58.309l-7.416-2.041v-4.139c0-10.749-8.085-19.933-18.834-19.933H148.02V30.23c0-8.148-2.934-15.737-8.565-21.367 C133.74,3.147,126.258,0,118.236,0c-8.041,0-15.576,3.147-21.292,8.863c-4.069,4.068-6.804,9.098-8.055,14.578l-27.511-7.9 c-1.162-0.333-2.356-0.519-3.559-0.519c-5.777,0-10.92,3.643-12.51,9.186l-2.347,7.987h-2.239 c-10.749,0-19.703,9.184-19.703,19.933v55.247L4.822,164.638c-1.976,6.89,1.879,14.103,8.768,16.077l7.43,2.156v4.024 c0,10.749,8.954,19.3,19.703,19.3h62.003l60.593,17.374c1.162,0.333,2.361,0.476,3.565,0.476c5.777,0,10.922-3.982,12.511-9.525 l2.383-8.325h2.408c10.749,0,18.834-8.551,18.834-19.3v-56.47l16.205-56.04C221.201,67.496,217.326,60.283,210.436,58.309z M102.646,27.164c0.605-2.99,2.147-5.713,4.5-8.067c2.95-2.949,6.903-4.519,11.131-4.52c4.194,0,8.128,1.652,11.078,4.603 c3.011,3.012,4.603,6.58,4.603,10.714l0.003,2.302h-13.021L102.646,27.164z M42.02,53.195h46.159l0.032,19.179l0.011,0.353 c0.418,4.989,2.401,9.749,5.957,13.303c4.019,4.02,8.841,6.259,14.841,6.259v0.013c6-0.001,11.223-2.21,15.245-6.233 c4.022-4.022,6.341-9.36,6.341-15.057c-0.046-5.942-0.111-7.59-0.196-8.185c-0.383-3.696-3.408-6.466-7.128-6.466 c-3.723,0-6.759,2.771-7.139,6.47c-0.086,0.609-0.169,2.248-0.072,8.207c0,1.77-0.689,3.436-1.946,4.693 c-1.258,1.258-2.924,1.95-4.694,1.951c-1.859,0-3.863-0.728-5.082-1.946c-1.375-1.376-2.33-3.081-2.33-4.678V53.195h80v132h-140 V53.195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.02,116.437c0-6.761-5.48-12.241-12.24-12.241H66.26c-6.76,0-12.24,5.481-12.24,12.241v0.518 c0,6.761,5.48,12.241,12.24,12.241h92.52c6.76,0,12.24-5.481,12.24-12.241V116.437z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.02,156.437c0-6.761-5.48-12.241-12.24-12.241H66.26c-6.76,0-12.24,5.481-12.24,12.241v0.518 c0,6.761,5.48,12.241,12.24,12.241h92.52c6.76,0,12.24-5.481,12.24-12.241V156.437z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.565988924f04a012f72bc22d7b1d748a.svg";
export { ForwardRef as ReactComponent };